var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWillBeLeasedOverlapSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "#1B2F34",
    stroke: "#8AA9B0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#8AA9B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5C2.4 2.9 6.66667 7.16667 9.5 10",
    stroke: "#8AA9B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1L11 8",
    stroke: "#8AA9B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWillBeLeasedOverlapSelected);
export default __webpack_public_path__ + "static/media/will-be-leased_overlap_selected.ac7ac9734a2bc90eca2bddb99a3de2be.svg";
export { ForwardRef as ReactComponent };